import styled from "styled-components";
import { breakpoints } from "styles";
import { Container } from "styles/common/container";

export const HeroSectionWrapper = styled.section`
  position: relative;
  padding: 48px 0 0 0;
  background: ${({ theme }) => theme.colors.brand[500]};

  @media ${breakpoints.tablet} {
    padding: 0;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: repeating-conic-gradient(
      ${({ theme }) => theme.colors.brand["900"]} 0 9deg,
      ${({ theme }) => theme.colors.brand["800"]} 9deg 18deg
    );
    background-position: 0% 0%;
    background-size: 100% 200%;
    opacity: 0.5;

    @media ${breakpoints.tablet} {
      background: repeating-conic-gradient(
        ${({ theme }) => theme.colors.brand["900"]} 0 12deg,
        ${({ theme }) => theme.colors.brand["800"]} 12deg 30deg
      );
      background-size: 100% 250%;
    }
  }
`;

export const HeroSection = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 400px;
  overflow: hidden;

  @media ${breakpoints.tablet} {
    height: initial;
    flex-direction: row;
  }
`;

export const HeroSectionContent = styled.div`
  position: relative;
  z-index: 2;
  color: ${({ theme }) => theme.colors.white};
  padding: 0 30px;
  @media ${breakpoints.tablet} {
    padding: 36px;
  }
  @media ${breakpoints.laptop} {
    padding: 0;
  }
`;

export const HeroSectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  margin: 0 0 16px 0;
  line-height: 1.5;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  }

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  }
`;

export const HeroSectionContentHighlight = styled.p`
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.yellow[300]};
  margin: 0 0 10px 0;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  }
`;

export const HeroSectionDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizes["md"]};

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
`;

export const HeroSectionCTA = styled.a<{ isOutlined: boolean }>`
  --webkit-appearance: none;
  background-color: ${({ theme, isOutlined }) =>
    isOutlined ? "transparent" : theme.colors.brand["100"]};
  color: ${({ theme, isOutlined }) =>
    isOutlined
      ? theme.colors.brand["100"]
      : theme.colors.brand["500"]} !important;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 4px;
  box-shadow: none;
  border: ${({ theme, isOutlined }) =>
    isOutlined ? `2px solid ${theme.colors.brand["100"]}` : "none"};
  cursor: pointer;
  max-width: 220px;
  white-space: nowrap;
  text-decoration: none;
`;

export const HeroSectionImageWrapper = styled.div`
  position: relative;
  width: 100vw;
  z-index: 2;
  right: -10px;

  @media ${breakpoints.tablet} {
    width: 100%;
    padding: 0;
    bottom: -30px;
  }

  @media ${breakpoints.laptop} {
    padding-top: 0;
    right: 0px;
  }
`;

export const HeroSectionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${breakpoints.tablet} {
    flex-direction: row;
  }
`;
